
import { Component, Prop, Vue } from "nuxt-property-decorator";
import RouterLink from "~/components/atoms/text/RouterLink.vue";
import CountiesList from "~/components/molecules/display/CountiesList.vue";
import { Location } from "~/types/Location";

@Component({
  components: {
    RouterLink,
    CountiesList,
  },
})
export default class DistrictLocationsList extends Vue {
  @Prop({ default: false }) isDistrictCity!: boolean;
  @Prop({ default: false }) isDistrictPage!: boolean;
  @Prop({ default: false }) isStatePage!: boolean;
  @Prop({ required: true }) districtName!: string;
  @Prop({ required: true }) locations!: Location[];
  @Prop({ default: false }) isPelletsSite!: boolean;

  getLocationKey(location: Location, index: number): string {
    if (this.isDistrictCity) {
      const zipcode = "zipcode" in location ? location.zipcode : "";
      return `${index}-${location.name}-${zipcode}`;
    }
    return `${index}-${location.name}`;
  }

  getLocationLink(location: Location): string {
    if (this.isDistrictCity || this.isDistrictPage) {
      return location.link;
    }

    const baseUrl = this.isPelletsSite ? "pelletspreise" : "heizoelpreise";
    return `/${baseUrl}/bundeslaender/${this.$route.params.category.toLowerCase()}/${location.link.toLowerCase()}`;
  }

  getLocationTitle(location: Location): string {
    if (this.isStatePage) {
      return `Weiter zum Landkreis ${location.name}`;
    }
    if (this.isDistrictCity || this.isDistrictPage) {
      return `Erfahren Sie mehr über die aktuelle ${this.priceType}-Entwicklung in ${location.name}`;
    }
    return `Weiter zur Ansicht zu ${location.name}`;
  }

  getLocationDisplayName(location: Location): string {
    if (this.isDistrictCity) {
      const zipcode = "zipcode" in location ? location.zipcode : "";
      return `${zipcode} ${this.districtName}`;
    }
    return "displayName" in location ? location.displayName : location.name;
  }

  getPostalCodeDescription(): string {
    return `Für nähere Informationen zum ${this.priceType} in den Postleitzahlen der kreisfreien Stadt ${this.districtName}, wählen Sie eine PLZ aus der Liste.`;
  }

  getDistrictLocationDescription(): string {
    return `Für nähere Informationen zum ${this.priceType} in den Ortschaften des Landkreises ${this.districtName}, wählen Sie einen Ort aus der Liste.`;
  }

  getCountyListDescription(): string {
    return `Für nähere Informationen zum ${this.priceType} in den Landkreisen ${this.districtName}s wählen Sie einen Landkreis aus der Liste.`;
  }

  get priceType(): string {
    return this.isPelletsSite ? "Pelletspreis" : "Heizölpreis";
  }

  get districtSuffixText(): string {
    if (this.isDistrictPage) {
      return `des Landkreises ${this.districtName}`;
    }
    return `in ${this.districtName}`;
  }

  get headerText(): string {
    if (this.isDistrictCity) {
      const baseText = `Postleitzahlen der kreisfreien Stadt ${this.districtName}`;
      return this.isPelletsSite ? baseText : `Heizölpreise in ${baseText}`;
    }

    if (this.isDistrictPage) {
      return this.isPelletsSite
        ? "Weitere Ortschaften mit Pelletspreisen"
        : "Heizölpreise in weiteren Ortschaften";
    }

    return this.isPelletsSite
      ? "Landkreise mit Pelletspreisen"
      : "Heizölpreise der Landkreise";
  }

  get descriptionText(): string {
    if (this.isDistrictCity) {
      return this.getPostalCodeDescription();
    }

    if (this.isDistrictPage) {
      return this.getDistrictLocationDescription();
    }

    return this.getCountyListDescription();
  }
}
